import { AlertCircle, LoaderCircle } from "lucide-react";
import type { PropsWithChildren, ReactNode } from "react";

export function PageHeader({ eyebrow, title, description, action }: { eyebrow?: string; title: string; description?: string; action?: ReactNode }) {
  return <header className="page-header"><div>{eyebrow && <p className="eyebrow">{eyebrow}</p>}<h1>{title}</h1>{description && <p>{description}</p>}</div>{action}</header>;
}

export function Panel({ children, className = "" }: PropsWithChildren<{ className?: string }>) {
  return <section className={`panel ${className}`}>{children}</section>;
}

export function Empty({ title, children }: PropsWithChildren<{ title: string }>) {
  return <div className="empty"><span aria-hidden>✦</span><h2>{title}</h2><p>{children}</p></div>;
}

export function Loading() { return <div className="loading"><LoaderCircle className="spin" /><span>Getting the ledger…</span></div>; }

export function ErrorNotice({ error }: { error: unknown }) {
  return <div className="error-notice" role="alert"><AlertCircle /><span>{error instanceof Error ? error.message : "Something went wrong."}</span></div>;
}

export function Field({ label, hint, children }: PropsWithChildren<{ label: string; hint?: string }>) {
  return <label className="field"><span>{label}</span>{children}{hint && <small>{hint}</small>}</label>;
}
